import { render, staticRenderFns } from "./LeakageCauseEquipmentDetailQuestion.vue?vue&type=template&id=68488cd5&scoped=true"
import script from "./LeakageCauseEquipmentDetailQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseEquipmentDetailQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseEquipmentDetailQuestion.vue?vue&type=style&index=0&id=68488cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68488cd5",
  null
  
)

export default component.exports